export default "__VITE_ASSET__DmAWQQ4f__"